import React, {Component} from 'react';
import './ProfileCoupons.css';

import actions from './profileCoupons.actions';
import profileAction from '../profile.actions';
import couponActions from '../../community/coupons/coupons.actions';
import streamAction from '../../stream/stream.actions';
import {sessionActions} from '../../user';
import {
	getUnapprovedCoupons,
	getApprovedCoupons,
	getWalletCoupons
} from './profileCoupons.selector';

import {getProviderUniqueName} from '../../community/community.selectors';
import {ProfileSidePane} from '../ProfileSidePane';
import {connect} from 'react-redux';
import CouponCard from '../../community/coupons/coupon-card/CouponCard';
import {EmptyMessage, DocumentTitle} from '../../widgets';
import confirmActions from '../../widgets/confirmation.actions';
import profileActions from '../profile.actions';
import {uiActions} from '../../chrome';

class ProfileCoupons extends Component {
	componentDidMount = () => {
		let isViewingOwnProfile;
		let currentProfileProviderUuid;

		// fetch coupons for current provider
		if (this.props.profile && this.props.profile.uuid) {
			currentProfileProviderUuid = this.props.profile.uuid;
			this.props.fetchProfileCoupons(currentProfileProviderUuid);
		}

		// check if viewing own profile
		if (
			this.props.sessionProvider &&
			this.props.sessionProvider.user &&
			this.props.sessionProvider.user.uuid === this.props.profile.user.uuid
		) {
			isViewingOwnProfile = true;
		}

		// get current session user id
		if (
			isViewingOwnProfile &&
			this.props.session &&
			this.props.profile &&
			this.props.profile.user &&
			this.props.session.current &&
			this.props.session.current.user
		) {
			let currentSessionUserUuid = this.props.session.current.user.uuid;
			this.props.fetchUserWalletCoupons(currentSessionUserUuid);
		}
	};

	// callback funtion for create promotion click from profileSidePane section
	createPromotion = () => {
		this.props.showAffiliatedCommunities(this.props.session.current.user.uuid);
	};

	render() {
		const {sessionProvider, profileCoupons, retrieveCommunity, session, screenSize} = this.props;

		let currentUserUuid = null;
		let walletCoupons = [];
		let couponsPendingApproval = [];
		let approvedCoupons = [];
		let isViewingOwnProfile;

		if (session.current && session.current.user) {
			currentUserUuid = session.current.user.uuid;
		}

		// check if viewing own profile
		if (
			this.props.sessionProvider &&
			this.props.sessionProvider.user &&
			this.props.profile &&
			this.props.profile.user &&
			this.props.sessionProvider.user.uuid === this.props.profile.user.uuid
		) {
			isViewingOwnProfile = true;
		}

		if (isViewingOwnProfile) {
			couponsPendingApproval = getUnapprovedCoupons(this.props);
			walletCoupons = getWalletCoupons(this.props);
		}

		approvedCoupons = getApprovedCoupons(this.props);

		return (
			<DocumentTitle title="Promotions">
				<main>
					{isViewingOwnProfile && (
						<ProfileSidePane
							profile={this.props.profile}
							isPromotionPage={true}
							createPromotion={this.createPromotion}
						/>
					)}

					<div className="profileCouponContainer">
						{isViewingOwnProfile && walletCoupons && walletCoupons.length !== 0 && (
							<section className="pendingCouponList">
								<div className="couponStatusTitle">
									<h3>My Coupon Wallet</h3>
								</div>
								<div className="coupons">
									{walletCoupons && walletCoupons.length
										? walletCoupons.map(coupon => (
												<CouponCard
													key={coupon.uuid}
													screenSize={screenSize}
													size="small"
													avatarImage={coupon.created_by.profile.avatarImage}
													firstname={coupon.created_by.user.firstname}
													lastname={coupon.created_by.user.lastname}
													businessName={coupon.created_by.user.businessName}
													couponUuid={coupon.uuid}
													productLink={coupon.productLink}
													code={coupon.code}
													description={coupon.description}
													expiryDate={coupon.expiryDate}
													showActions={false}
													showOptions={true}
													coupon={coupon}
													showCommunityName={true}
													redirectLink={'/coupons/' + coupon.community.profile.uniqueName}
													providerProfileLink={'/@' + coupon.created_by.profile.uniqueName}
													isWallet={true}
												/>
										  ))
										: null}
								</div>
							</section>
						)}

						{isViewingOwnProfile && couponsPendingApproval && couponsPendingApproval.length !== 0 && (
							<section className="pendingCouponList">
								<div className="couponStatusTitle">
									<h3>Promotions Pending Approval</h3>
								</div>
								<div className="coupons">
									{couponsPendingApproval && couponsPendingApproval.length
										? couponsPendingApproval.map(coupon => (
												<CouponCard
													key={coupon.uuid}
													screenSize={screenSize}
													size="small"
													avatarImage={coupon.created_by.profile.avatarImage}
													firstname={coupon.created_by.user.firstname}
													lastname={coupon.created_by.user.lastname}
													businessName={coupon.created_by.user.businessName}
													couponUuid={coupon.uuid}
													code={coupon.code}
													productLink={coupon.productLink}
													description={coupon.description}
													expiryDate={coupon.expiryDate}
													showActions={false}
													showOptions={true}
													coupon={coupon}
													showCommunityName={true}
													redirectLink={'/coupons/' + coupon.community.profile.uniqueName}
													providerProfileLink={'/@' + coupon.created_by.profile.uniqueName}
													options={[
														{
															key: 'header',
															icon: 'icon icon-delete',
															label: 'Remove this coupon',
															onSelect: e => {
																e.stopPropagation();
																this.props.deleteCoupon(coupon.uuid, currentUserUuid);
															}
														},
														{
															key: 'edit-coupon',
															icon: 'icon icon-mode_edit',
															label: 'Edit this coupon',
															onSelect: e => {
																e.stopPropagation();
																this.props.editCoupon(coupon, 'PROFILE_COUPON_PENDING_APPROVAL');
															}
														}
													]}
													ownCoupons={true}
												/>
										  ))
										: null}
								</div>
							</section>
						)}

						{approvedCoupons && approvedCoupons.length !== 0 && (
							<section className="approvedCouponList">
								<div className="couponStatusTitle">
									{isViewingOwnProfile ? <h3>Approved Promotions</h3> : <h3>Current Promotions</h3>}
								</div>
								<div className="coupons">
									{approvedCoupons && approvedCoupons.length
										? approvedCoupons.map(coupon => (
												<CouponCard
													key={coupon.uuid}
													screenSize={screenSize}
													size="small"
													avatarImage={coupon.created_by.profile.avatarImage}
													firstname={coupon.created_by.user.firstname}
													lastname={coupon.created_by.user.lastname}
													businessName={coupon.created_by.user.businessName}
													couponUuid={coupon.uuid}
													code={coupon.code}
													productLink={coupon.productLink}
													description={coupon.description}
													expiryDate={coupon.expiryDate}
													showActions={false}
													showOptions={isViewingOwnProfile}
													showCommunityName={true}
													coupon={coupon}
													redirectLink={'/coupons/' + coupon.community.profile.uniqueName}
													providerProfileLink={'/@' + coupon.created_by.profile.uniqueName}
													options={[
														{
															key: 'remove-coupon',
															icon: 'icon icon-delete',
															label: 'Remove this coupon',
															onSelect: e => {
																e.stopPropagation();
																this.props.confirmRemoval(coupon.uuid, currentUserUuid);
															}
														},
														{
															key: 'edit-coupon',
															icon: 'icon icon-mode_edit',
															label: 'Edit this coupon',
															onSelect: e => {
																e.stopPropagation();
																this.props.editCoupon(coupon, 'PROFILE_COUPON_APPROVED');
															}
														},
														{
															key: 'promotion-statistics',
															icon: 'icon icon-timeline',
															label: 'View Promotion Statistics',
															onSelect: e => {
																e.stopPropagation();
																this.props.viewPromotionStatistics(coupon);
															}
														}
													]}
													ownCoupons={isViewingOwnProfile}
												/>
										  ))
										: null}
								</div>
							</section>
						)}
						{walletCoupons &&
							walletCoupons.length === 0 &&
							couponsPendingApproval &&
							couponsPendingApproval.length === 0 &&
							approvedCoupons &&
							approvedCoupons.length === 0 && (
								<EmptyMessage>No active promotions or redeemed coupon at this moment.</EmptyMessage>
							)}
					</div>
				</main>
			</DocumentTitle>
		);
	}
}

const mapStateToProps = state => {
	return {
		session: state.session,
		screenSize: state.ui.screenSize,
		sessionProvider: state.session && state.session.current,
		profileCoupons: state.profileCoupon,
		profile: state.profile
	};
};

const mapDispatchToProps = dispatch => {
	return {
		fetchProfileCoupons: providerUuid => dispatch(actions.fetchProviderCoupons(providerUuid)),
		fetchUserWalletCoupons: userUuid => dispatch(actions.fetchUserWalletCoupons(userUuid)),
		confirmRemoval: (couponUuid, userUuid) =>
			dispatch(
				confirmActions.open({
					title: `Do you really want to remove this Coupon?`,
					message: 'The coupon will no longer be displayed on community profile. Are you sure?',
					onConfirm: () => dispatch(actions.deleteCoupon(couponUuid, userUuid))
				})
			),
		editCoupon: (coupon, section) => {
			dispatch(couponActions.editCoupon(coupon, section));
		},
		retrieveOnlyProfile: uniqueName => dispatch(profileActions.retrieveOnlyProfile(uniqueName)),
		viewPromotionStatistics: coupon => {
			dispatch(couponActions.setCouponStatistics({couponUuid: coupon.uuid, source: 'profile'}));
			dispatch(uiActions.uiModal('coupon-statistics'));
		},
		showAffiliatedCommunities: currentUserUuid => {
			dispatch(sessionActions.retrieveSessionAffiliations(currentUserUuid));
			dispatch(uiActions.uiModal('mobile-community-list'));
			dispatch(streamAction.communityListingModelOpened());
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ProfileCoupons);



// WEBPACK FOOTER //
// ./src/profile/coupons/ProfileCoupons.js